import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      '.title-container': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      },
      '.image-info-wrapper': {
        display: 'flex',
        gap: rem(16),
        alignItems: 'center',
        marginBottom: rem(12),
        '.product-image': {
          borderRadius: rem(3),
          width: rem(120),
          height: rem(120),
          objectFit: 'contain',
        },
      },
      '.title-divider': {
        borderTop: '1px solid #e4e8ec',
        margin: '16px 0 12px',
        [theme.fn.smallerThan('sm')]: {
          marginTop: rem(9),
        },
      },
    },
  }
})
